import { AfterViewInit, Component, Input } from '@angular/core';
import { MAT_CHECKBOX_CLICK_ACTION } from '@angular/material';

import { DEFAULT_FILTERS, IFilters } from '../../models/filters';
import { FiltersService } from '../../services/filters.service';

/** Component for setting filters on the plot data */
@Component({
    selector: 'sci-filter-menu',
    templateUrl: './filter-menu.component.html',
    styles: [ './menu.component.scss' ],
    providers: [
        { provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'noop' } // requires us to manually update checkbox models
    ]
})
export class FilterMenuComponent implements AfterViewInit {
    @Input() darkTheme: boolean;
    @Input() plotId: string;
    filters: IFilters = DEFAULT_FILTERS;
    activeFilter: boolean;
    filterError: string;

    constructor( private _filtersService: FiltersService ) {}

    ngAfterViewInit() {
        this._filtersService.getFilters$( this.plotId ).subscribe(
            newFilters => this.filters = newFilters
        );
    }

    updateFilters() {
        if ( this.validateFilters( this.filters ) ) {
            // see if any filters are active
            if ( this.filters.change.enabled || this.filters.delta.enabled || this.filters.minmax.enabled ) {
                this.activeFilter = true;
            } else {
                this.activeFilter = false;
            }
            this._filtersService.setFilters( this.plotId, this.filters );
        }
    }

    validateFilters( filters: IFilters ) {
        let valid = true;
        this.filterError = '';
        // delta filters require a valid number
        if ( filters.delta.enabled ) {
            if ( typeof filters.delta.value !== 'number' || filters.delta.value === null || filters.delta.value <= 0 ) {
                valid = false;
                this.filterError = 'Max Change must be a valid positive number';
            }
        }
        // min/max filter requires 2 valid numbers and min < max
        if ( filters.minmax.enabled ) {
            if ( typeof filters.minmax.min !== 'number' || typeof filters.minmax.max !== 'number' ) {
                valid = false;
                this.filterError = 'Min and Max must be numbers';
            } else if ( filters.minmax.min === null || filters.minmax.max === null ) {
                valid = false;
                this.filterError = 'Both Min and Max are required values';
            } else if ( filters.minmax.min >= filters.minmax.max ) {
                valid = false;
                this.filterError = 'Min must be less than Max';
            }
        }
        return valid;
    }
}
